// For Bespoke Dashboards
import React, { useState, useEffect } from "react";
import moment from "moment";
import _ from "lodash";
import Chart from "react-apexcharts";

const TimeseriesChart = ({
  data,
  parameter,
  type,
  height,
  min,
  max,
  target
}) => {
  const [series, setSeries] = useState([]);
  const [options, setOptions] = useState({
    chart: {
      id: "basic-timeseries"
    },
    xaxis: {
      type: "datetime",
      labels: { show: true },
      axisTicks: { show: true }
    },
    colors: ["#65B32E"],
    stroke: { curve: "straight" },
    dataLabels: { enabled: false },
    tooltip: {
      theme: "dark",
      x: { show: false },
      marker: { show: false },
      y: {
        title: {
          formatter: () => {
            return "";
          }
        }
      }
    }
  });
  const [chartHeight, setChartHeight] = useState(275);

  useEffect(() => {
    if (height === "small") {
      setChartHeight(200);
    } else if (height === "medium") {
      setChartHeight(275);
    } else if (height === "large") {
      setChartHeight(350);
    } else {
      setChartHeight(275);
    }
  }, [height]);

  useEffect(() => {
    if (!_.isEmpty(data)) {
      setSeries([
        {
          name: data[parameter].Name,
          data: data[parameter].data.map(d => {
            return {
              y: d.PARAM_VALUE.toFixed(data[parameter].Precision),
              x: moment(d.REAL_DATE).hour(d.REAL_HOUR)
            };
          })
        }
      ]);
      setOptions(currentOptions => {
        return {
          ...currentOptions,
          chart: {
            id: parameter,
            toolbar: { show: false },
            zoom: { enabled: false }
          },
          title: {
            text: data[parameter].Name
          },
          yaxis: {
            labels: {
              minWidth: 20
            },
            min: minY => (min ? parseFloat(min) : minY),
            max: maxY => (max ? parseFloat(max) : maxY)
          },
          annotations: {
            yaxis: target
              ? [
                  {
                    y: parseFloat(target),
                    borderColor: "#e67e22",
                    label: {
                      borderColor: "#e67e22",
                      style: {
                        color: "#fff",
                        background: "#e67e22"
                      },
                      text: "Target"
                    }
                  }
                ]
              : []
          }
        };
      });
    }
  }, [data, parameter, min, max, target]);
  return (
    <Chart
      options={options}
      series={series}
      type={type ? type : "area"}
      height={chartHeight}
      width="99%"
    />
  );
};

export default TimeseriesChart;
